import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import ImageUploader from "../../../../components/inputs/imageUploader/ImageUploader";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchSquadImages } from "../../../../features/images/squadImages/squadImagesSlice";
import styles from "./squadImages.module.css";
import SquadOneImage from "./squadOneImage/SquadOneImage";

const SquadImages = () => {
  const dispatch = useDispatch();

  const {
    fetchStatus,
    deleteStatus,
    list: squadImages,
    uploadStatus,
  } = useSelector((state) => state.squadImages);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchSquadImages());
    }
  }, [dispatch, fetchStatus]);

  if (
    fetchStatus === "loading" ||
    deleteStatus === "loading" ||
    uploadStatus === "loading"
  ) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textTitle">جميع صور السكوادات</TextWrapper>
        <div className={styles.imageUploaderWrapper}>
          <ImageUploader tag={"squad"} label="رفع صورة جديدة" />
        </div>
      </div>
      <div className={styles.allImagesWrapper}>
        <DisplayContainer className={styles.imagesDisplay}>
          {squadImages.map((item) => {
            return (
              <SquadOneImage
                key={item._id}
                path={item.path}
                name={item.name}
                id={item._id}
              />
            );
          })}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default SquadImages;
